export const WS_URL = 'wss://hypr.website/ws';
